import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      border: 'none',
      '& .MuiOutlinedInput-input': {
        // padding: '10px !important',
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main
      }
    },
    '& label': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  select: {
    '& .MuiOutlinedInput-input': {
      padding: '10px !important'
    }
  },
  checkbox: {
    color: theme.palette.blue_300.main,
    '&.Mui-checked': {
      color: theme.palette.blue_300.main
    }
  },
  iconChevronDown: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    marginRight: 5
  },
  menuItem: {
    padding: '0 16px',
    height: 30,
  },
  menuList: {
    overflowY: 'auto',
    ...theme.scrollbarStyles,
    // maxHeight: '300px !important',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  }
}))
